import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DropDown from './DropDown';
import LoginModal from '../LoginModal';
import { getUser, clearUser } from '../../helpers/sessionHelper';
import { FaUser } from 'react-icons/fa';

export default function Header({
  logoUrl,
  colorVariant,
  cart,
  actionBtnText,
  actionBtnUrl,
}) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  // Function to check if user is logged in using sessionHelper
  const checkAuthStatus = () => {
    try {
      const user = getUser();
      if (user) {
        setIsLoggedIn(true);
        setUserData(user);
        return true;
      } else {
        setIsLoggedIn(false);
        setUserData(null);
        return false;
      }
    } catch (error) {
      console.error('Error checking auth status:', error);
      setIsLoggedIn(false);
      setUserData(null);
      return false;
    }
  };

  // Function to handle login button click
  const handleLoginClick = () => {
    if (isLoggedIn) {
      // If logged in, navigate to dashboard
      navigate('/dashboard');
    } else {
      // If not logged in, show login modal
      setShowLoginModal(true);
    }
  };

  // Function to get display name
  const getDisplayName = () => {
    if (userData) {
      const firstName = userData.firstName || '';
      const lastName = '';
      if (firstName && lastName) {
        return `${firstName} ${lastName}`;
      } else if (firstName) {
        return firstName;
      } else if (userData.email) {
        return userData.email.split('@')[0]; // Fallback to email username
      }
    }
    return 'Login';
  };

  // Check auth status on component mount
  useEffect(() => {
    checkAuthStatus();

    // Check periodically (every 30 seconds) to handle any changes
    const interval = setInterval(checkAuthStatus, 30000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  // Check auth status when login modal closes
  useEffect(() => {
    if (!showLoginModal) {
      // Small delay to ensure cookies are set
      setTimeout(() => {
        checkAuthStatus();
      }, 100);
    }
  }, [showLoginModal]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <style>
        {`
          @media (max-width: 768px) {
            #mobile-book-now-btn {
              display: block !important;
            }
            #desktop-user-btn {
              display: none !important;
            }
          }
          @media (min-width: 769px) {
            // #mobile-book-now-btn {
            //   display: none !important;
            // }
            #desktop-user-btn {
              display: flex !important;
            }
          }
        `}
      </style>
      <div
        style={{
          height: '30px',
          width: '100%',
          background: '#00f3ff',
          color: '#111',
          fontWeight: 700,
          fontSize: '13px',
          letterSpacing: '1px',
          padding: '0px 0',
          overflow: 'hidden',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 1100,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="topbar-desktop">
        Booking Live Now | Avail Exclusive Discount – Valid for Limited Time | IGNITE YOUR GAME
        </span>
        <span className="topbar-mobile" style={{ display: 'none', width: '100%' }}>
          <marquee behavior="scroll" direction="left" scrollamount="7" style={{ width: '100%' }}>
            Booking Live Now | Avail Exclusive Launch Discount - Valid Till 10th July 2025 | IGNITE YOUR GAME
          </marquee>
        </span>
        <style>{`
        .lg-hide{
          display: none !important;
        }
          @media (max-width: 768px) {
            .topbar-desktop { display: none !important; }
            .topbar-mobile { display: block !important;
                    height: 26px; }
                  
          @media (min-width: 769px) {
            .topbar-desktop { display: block !important; 
            }
            .topbar-mobile { display: none !important; }
            
          
          }
        `}
        
        </style>
      </div>  
      <header
        className={`cs_site_header cs_style_1 cs_sticky_header ${colorVariant ? colorVariant : 'cs_primary_color'
          } ${isSticky ? 'cs_gescout_show' : ''}`}
        style={{
          top: '30px',
          zIndex: 999
        }}
      >
        <div className="cs_main_header">
          <div className="container">
            <div className="cs_main_header_in">
              <div className="cs_main_header_left">
                <Link className="cs_site_branding" to="/">
                  <img src={logoUrl} alt="Logo" />
                </Link>
              </div>
              <div className="cs_main_header_center">
                <div className="cs_nav cs_medium cs_primary_font">
                  <ul
                    className={`${mobileToggle ? 'cs_nav_list cs_active' : 'cs_nav_list'
                      }`}
                  >
                    <li className=" cs_mega_menu">
                      <Link to="/" onClick={e => {
                        if (window.location.pathname === '/') {
                          e.preventDefault();
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        setMobileToggle(false);
                      }}>Home</Link>
                      {/* <DropDown>
                        <ul className="cs_mega_wrapper">
                          <li className="menu-item-has-children">
                            <Link to="/">Dark Version</Link>
                            <DropDown>
                              <ul>
                                <li>
                                  <Link to="/">Creative Agency</Link>
                                </li>
                                <li>
                                  <Link to="/marketing-agency">
                                    Marketing Agency
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/studio-agency">Studio Agency</Link>
                                </li>
                                <li>
                                  <Link to="/digital-agency">Digital Agency</Link>
                                </li>
                                <li>
                                  <Link to="/tech-startup">Tech Startup</Link>
                                </li>
                              </ul>
                            </DropDown>
                          </li>
                          <li className="menu-item-has-children">
                            <Link to="/">Light Version</Link>
                            <DropDown>
                              <ul>
                                <li>
                                  <Link to="/light">Creative Agency</Link>
                                </li>
                                <li>
                                  <Link to="/light/marketing-agency">
                                    Marketing Agency
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/light/studio-agency">
                                    Studio Agency
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/light/digital-agency">
                                    Digital Agency
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/light/tech-startup">
                                    Tech Startup
                                  </Link>
                                </li>
                              </ul>
                            </DropDown>
                          </li>
                        </ul>
                      </DropDown> */}
                    </li>
                    <li>
                      <Link to="/about" onClick={e => {
                        if (window.location.pathname === '/about') {
                          e.preventDefault();
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        setMobileToggle(false);
                      }}>About</Link>
                    </li>
                    <li className="">
                      <Link to="/service" onClick={e => {
                        if (window.location.pathname === '/service') {
                          e.preventDefault();
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        setMobileToggle(false);
                      }}>Services</Link>
                      {/* <DropDown>
                        <ul>
                          <li>
                            <Link to="service">Service</Link>
                          </li>
                          <li>
                            <Link to="service/service-details">
                              Service Details
                            </Link>
                          </li>
                        </ul>
                      </DropDown> */}
                    </li>
                    {/* <li className="menu-item-has-children">
                      <Link to="blog">Blog</Link>
                      <DropDown>
                        <ul>
                          <li>
                            <Link to="blog">Blog Standard</Link>
                          </li>
                          <li>
                            <Link to="blog-list">Blog List</Link>
                          </li>
                          <li>
                            <Link to="blog/blog-details">Blog Details</Link>
                          </li>
                        </ul>
                      </DropDown>
                    </li> */}
                    {/* <li className="menu-item-has-children">
                      <Link to="shop">Shop</Link>
                      <DropDown>
                        <ul>
                          <li>
                            <Link to="shop">Our Shop</Link>
                          </li>
                          <li>
                            <Link to="shop/product-details">Shop Details</Link>
                          </li>
                          <li>
                            <Link to="shop/cart">Cart</Link>
                          </li>
                          <li>
                            <Link to="shop/checkout">Checkout</Link>
                          </li>
                          <li>
                            <Link to="shop/success">Success Order</Link>
                          </li>
                          <li>
                            <Link to="shop/wishlist">Wishlist</Link>
                          </li>
                        </ul>
                      </DropDown>
                    </li> */}
                    {/* <li className="menu-item-has-children">
                      <Link to="/">Pages</Link>
                      <DropDown>
                        <ul>
                          <li>
                            <Link to="portfolio">Portfolio</Link>
                          </li>
                          <li>
                            <Link to="portfolio/portfolio-details">
                              Portfolio Details
                            </Link>
                          </li>
                          <li>
                            <Link to="case-study-details">
                              Case Study Details
                            </Link>
                          </li>
                          <li>
                            <Link to="team">Team</Link>
                          </li>
                          <li>
                            <Link to="team/team-details">Team Details</Link>
                          </li>
                        </ul>
                      </DropDown>
                    </li> */}

                    <li>
                      <Link to="/courts" onClick={e => {
                        if (window.location.pathname === '/courts') {
                          e.preventDefault();
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        setMobileToggle(false);
                      }}>Courts </Link>
                    </li>
                    {/* <li>
                      <Link to="/shop/booking" onClick={() => setMobileToggle(false)}>Book Now </Link>
                    </li> */}
                    <li>
                      <Link to="/contact" onClick={e => {
                        if (window.location.pathname === '/contact') {
                          e.preventDefault();
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        setMobileToggle(false);
                      }}>Contact</Link>
                    </li>
                    <li>
                      <button
                        id="mobile-book-now-btn"
                        style={{ marginTop: '20px' }}
                        onClick={e => {
                          if (window.location.pathname === '/shop/booking') {
                            e.preventDefault();
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            setMobileToggle(false);
                          } else {
                            navigate('/shop/booking');
                            setMobileToggle(false);
                          }
                        }}
                        className={`cs_btn cs_style_1  ${colorVariant ? 'cs_btn_white' : ''}`}
                      >
                        Book Now
                      </button>
                    </li>
                    {/* <li style={{ marginTop: '20px' }}>
                      <button
                        onClick={() => {
                          handleLoginClick();
                          setMobileToggle(false);
                        }}
                        className={`cs_btn cs_style_1 ${isLoggedIn ? 'cs_btn_user' : ''}`}
                        style={{
                          borderColor: isLoggedIn ? '#28a745' : ''
                        }}
                      >
                     
                        {isLoggedIn ? `Hi, ${getDisplayName()}` : 'Login'}
                      </button>
                    </li> */}
              
                  </ul>
                  <span
                    className={
                      mobileToggle
                        ? 'cs_menu_toggle cs_teggle_active'
                        : 'cs_menu_toggle'
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </div>
              </div>
              <div className="cs_main_header_right">
              <button 
                id="mobile-book-now-btn" 
                className="cs_btn cs_style_1 lg-hide" 
                onClick={() => navigate('/shop/booking')}
                style={{marginTop: '0px', zIndex: '9'}}
              >
                Book Now
              </button>
                {cart && (
                  <a href="shop/booking" className="cs_header_cart">
                    <svg
                      width={22}
                      height={22}
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_307_180)">
                        <path
                          d="M19.25 5.5H16.5C16.5 4.04131 15.9205 2.64236 14.8891 1.61091C13.8576 0.579463 12.4587 0 11 0C9.54131 0 8.14236 0.579463 7.11091 1.61091C6.07946 2.64236 5.5 4.04131 5.5 5.5H2.75C2.02065 5.5 1.32118 5.78973 0.805456 6.30546C0.289731 6.82118 0 7.52065 0 8.25L0 17.4167C0.00145554 18.6318 0.484808 19.7967 1.34403 20.656C2.20326 21.5152 3.3682 21.9985 4.58333 22H17.4167C18.6318 21.9985 19.7967 21.5152 20.656 20.656C21.5152 19.7967 21.9985 18.6318 22 17.4167V8.25C22 7.52065 21.7103 6.82118 21.1945 6.30546C20.6788 5.78973 19.9793 5.5 19.25 5.5ZM11 1.83333C11.9725 1.83333 12.9051 2.21964 13.5927 2.90728C14.2804 3.59491 14.6667 4.52754 14.6667 5.5H7.33333C7.33333 4.52754 7.71964 3.59491 8.40728 2.90728C9.09491 2.21964 10.0275 1.83333 11 1.83333ZM20.1667 17.4167C20.1667 18.146 19.8769 18.8455 19.3612 19.3612C18.8455 19.8769 18.146 20.1667 17.4167 20.1667H4.58333C3.85399 20.1667 3.15451 19.8769 2.63879 19.3612C2.12306 18.8455 1.83333 18.146 1.83333 17.4167V8.25C1.83333 8.00688 1.92991 7.77373 2.10182 7.60182C2.27373 7.42991 2.50688 7.33333 2.75 7.33333H5.5V9.16667C5.5 9.40978 5.59658 9.64294 5.76849 9.81485C5.94039 9.98676 6.17355 10.0833 6.41667 10.0833C6.65978 10.0833 6.89294 9.98676 7.06485 9.81485C7.23676 9.64294 7.33333 9.40978 7.33333 9.16667V7.33333H14.6667V9.16667C14.6667 9.40978 14.7632 9.64294 14.9352 9.81485C15.1071 9.98676 15.3402 10.0833 15.5833 10.0833C15.8264 10.0833 16.0596 9.98676 16.2315 9.81485C16.4034 9.64294 16.5 9.40978 16.5 9.16667V7.33333H19.25C19.4931 7.33333 19.7263 7.42991 19.8982 7.60182C20.0701 7.77373 20.1667 8.00688 20.1667 8.25V17.4167Z"
                          fill="currentColor"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_307_180">
                          <rect width={22} height={22} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="cs_header_cart_label">0</span>
                  </a>
                )}

                {/* <button
                  onClick={handleLoginClick}
                  className={`cs_btn cs_style_1 ${colorVariant ? 'cs_btn_white' : ''} ${isLoggedIn ? 'cs_btn_user' : ''}`}
                  style={{
                    backgroundColor: isLoggedIn ? '#28a745' : '',
                    borderColor: isLoggedIn ? '#28a745' : '',
                    marginLeft: '10px'
                  }}
                >
                  {isLoggedIn ? `Hi, ${getDisplayName()}` : 'Login'}
                </button> */}

                {/* <Link
                  to="/shop/booking"
                  className={`cs_btn cs_style_1  ${colorVariant ? 'cs_btn_white' : ''}`}
                >
                  Book Now
                </Link> */}
              
                  <button
                    onClick={e => {
                      if (isLoggedIn && window.location.pathname === '/dashboard') {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        setMobileToggle(false);
                      } else {
                        handleLoginClick();
                        setMobileToggle(false);
                      }
                    }}
                    className="cs_btn cs_style_1"
                    style={{
                      display: 'flex',
                      gap: '8px',
                      color: '#007bff', 
                      borderColor: '#007bff',
                      fontWeight: 500,
                      marginLeft: '10px'
                    }}
                    id="desktop-user-btn"
                  >
                    <FaUser style={{ color: '#00f3ff', fontSize: '24px' }} />
                    {/* {isLoggedIn ? `Hi, ${getDisplayName()}` : 'Login'} */}
                  </button>
              

              </div>
            </div>
          </div>
        </div>
      </header>

      {showLoginModal && (
        <LoginModal open={showLoginModal} onClose={() => setShowLoginModal(false)} />
      )}
    </>
  );
}

